import FormControl from '@material-ui/core/FormControl';
import {Detail, Flex} from '@dna/react';
import {logger} from "../../common/logger";
import {AppRadioButton} from "../../common/radio-button/AppRadioButton";
import {makeStyles} from "@material-ui/core/styles";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { RenderIf } from '../render-if/RenderIf';

export interface IRadioButtonProps<TItem,TValue>{
    controlLabel?:string;
    options:TItem[];
    nameField:string;
    valueField:string;
    value:TValue;
    getKey?:(va:TItem)=>string|number;
    onChange:(val:TValue)=>void;
    dataQa?:string;
}

const useStyles = makeStyles({
    label:{
        fontWeight:"normal"
    }
});

export function RadioButtonGroup<TItem,TValue>(props:Readonly<IRadioButtonProps<TItem,TValue>>){
    let classes = useStyles();

    let {options,nameField,valueField,onChange,getKey, value, controlLabel, dataQa} = props;

    const getLabel = (val:any)=>{
        return val[nameField] || '';
    };

    const getValue = (val:any)=>{
        return val[valueField] || '';
    };

    const handleChange = (event:any) => {
        onChange(event.target.value);
    };

    return (
        <Flex css={{
            gap:"small"
        }}>
            <RenderIf if={controlLabel != undefined}>
                <Detail
                    css={{
                        color: "muted"
                    }}
                    level="small"
                >
                    {controlLabel}
                </Detail>
            </RenderIf>
            <FormControl component="fieldset">
                <RadioGroup data-qa={dataQa} aria-label={controlLabel} name={controlLabel} value={value} onChange={handleChange}>
                    {options.map((x,index)=>{
                        let label = getLabel(x);
                        let value = getValue(x);
                        let key = getKey? getKey(x) : `${value}_${index}`;
                        return <FormControlLabel key={key} classes={{
                            label:classes.label
                        }} value={value} control={<AppRadioButton />} 
                        label={label} />;                
                    })}
                </RadioGroup>
            </FormControl>
        </Flex>
    );
};